export default "__VITE_ASSET__CiM2op8P__"